<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col sf-col-9">
				<sf-card class="p-0 h-100 card_bg">
					<pc-pcm-search ref="search" :scrId="scrId"></pc-pcm-search>
				</sf-card>
			</div>

			<div class="sf-col sf-col-15">
				<sf-card class="p-0 border-0 bg-transparent">
					<pc-pcm-table ref="table" :scrId="scrId" :tab1="getMessage_('QWCC001734')" :tab2="getMessage_('QWCC001735')"></pc-pcm-table>
				</sf-card>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/clma/PcPcm/store/helpers';
import PcPcmSearch from './Search/PcPcmSearch.vue';
import PcPcmTable from './Table/PcPcmTable.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmSearch, PcPcmTable },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		Refresh() {
			this.$refs.search.searchList();
		}
	}
};
</script>

<style></style>
